import { render, staticRenderFns } from "./PurchaseReturnDownload.vue?vue&type=template&id=6fbbf44e&"
import script from "./PurchaseReturnDownload.vue?vue&type=script&lang=js&"
export * from "./PurchaseReturnDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports